import { render, staticRenderFns } from "./IconTutorials.vue?vue&type=template&id=3fa2d947&"
import script from "./IconTutorials.vue?vue&type=script&lang=js&"
export * from "./IconTutorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports